import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class DetailedEstimateWithIcon extends Field {
  static subqueriesForModel() {
    return { originalEstimate: ['text'] };
  }

  get title() {
    return 'Detailed estimate with icon';
  }

  exampleContents(): FieldContentsData {
    return {
      prefix: 'D',
      text: '4d',
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.originalEstimate?.text) {
      return {
        prefix: 'D',
        text: record.originalEstimate.text,
      };
    }

    return {};
  }
}
